const buildBreadCrumbs = (
    plantName: string,
    menuNames: string[],
    appendPaths?: Record<number, string>, // Specify additional segments dynamically (e.g., "view" at index 2)
    queryParamIndices?: Record<number, Record<string, any>>, // Query params for specific indices
    stateIndices?: Record<number, Record<string, any>> // State for specific indices
) => {
    let path = "/usecase/injection-pdm";
    const breadcrumbs = [
        {
            menuName: `Home (${plantName})`,
            menuAction: path,
            state: stateIndices?.[0] || {}, // Root state if any
        },
    ];

    menuNames.forEach((name, index) => {
        let currentPath = path +`/${name.toLowerCase()}`;

        // Dynamically append user-defined segments (e.g., "view")
        // if (appendPaths?.[index + 1]) {
        //     path += `/${appendPaths[index + 1]}`;
        // }

        // Ensure appendPaths is applied **only** at index 2
        if (appendPaths?.[index + 1]) {
            currentPath += `/${appendPaths[index + 1]}`;
        }

        // Get query params for this specific level
        const queryParams = queryParamIndices?.[index + 1] || {};
        const queryString = new URLSearchParams(queryParams).toString();
        const menuAction = queryString ? `${currentPath}?${queryString}` : currentPath;

        // Get state for this specific level
        const state = stateIndices?.[index + 1] || {};

        breadcrumbs.push({ menuName: name, menuAction, state });
        path += `/${name.toLowerCase()}`;
    });

    return breadcrumbs;
};

export default buildBreadCrumbs;


// const buildBreadCrumbs = (
//     menuNames: string[],
//     queryParamIndices?: Record<number, Record<string, any>>, // Query params at specific indices
//     stateIndices?: Record<number, Record<string, any>> // State at specific indices
// ) => {
//     let path = "/usecase/injection-pdm";
//     const breadcrumbs = [
//         {
//             menuName: "Home",
//             menuAction: path,
//             state: stateIndices?.[0] || {}, // Root state if any
//         },
//     ];

//     menuNames.forEach((name, index) => {
//         path += `/${name.toLowerCase()}`;
        
//         // Get query params for this specific level
//         const queryParams = queryParamIndices?.[index + 1] || {};
//         const queryString = new URLSearchParams(queryParams).toString();
//         const menuAction = queryString ? `${path}?${queryString}` : path;

//         // Get state for this specific level
//         const state = stateIndices?.[index + 1] || {};

//         breadcrumbs.push({ menuName: name, menuAction, state });
//     });

//     console.log("breadcrumbs", breadcrumbs);

//     return breadcrumbs;
// };

// export default buildBreadCrumbs;



// const buildBreadCrumbs = (
//     menuNames: string[],
//     queryParamIndices?: Record<number, Record<string, any>>, // Specify query params for specific indices
//     stateIndices?: Record<number, Record<string, any>> // Specify state for specific indices
// ) => {
//     let path = "/usecase/injection-pdm";
//     const breadcrumbs = [
//         {
//             menuName: "Home",
//             menuAction: path,
//             state: stateIndices?.[0] || {}, // Apply state if specified for the root
//         },
//     ];

//     menuNames.forEach((name, index) => {
//         path += `/${name.toLowerCase()}`;
//         let menuAction = path;
//         let state: Record<string, any> = stateIndices?.[index + 1] || {}; // +1 to align with breadcrumb position

//         if (queryParamIndices?.[index + 1]) {
//             const queryString = new URLSearchParams(queryParamIndices[index + 1]).toString();
//             menuAction += `?${queryString}`;
//         }

//         breadcrumbs.push({ menuName: name, menuAction, state });
//     });

//     console.log("breadcrumbs",breadcrumbs)

//     return breadcrumbs;
// };

// export default buildBreadCrumbs;


// // const buildBreadCrumbs = (menuNames: string[], queryParams?: Record<string, any>, targetIndex?: number) => {
// //     let path = "/usecase/injection-pdm";
// //     const breadcrumbs = [{
// //         menuName: "Home",
// //         menuAction: path,
// //     }];
// //     menuNames.forEach((name, index) => {
// //         console.log("names", name)
// //         path += `/${name.toLowerCase()}`;
// //         let menuAction = path;
// //         if (queryParams && targetIndex === index) {
// //             const queryString = new URLSearchParams(queryParams).toString();
// //             menuAction += `?${queryString}`;
// //         }

// //         breadcrumbs.push({ menuName: name, menuAction });
// //     });

// //     console.log("breadcrumbs", breadcrumbs)

// //     return breadcrumbs;
// // };

// // export default buildBreadCrumbs;
